// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7g-3";
export var contentContainer = "_7g-0";
export var editorContainer = "_7g-1";
export var quillInputForm = "_7g-2";
export var zoneDivider = "_7g-4";